import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import axios from '../../../utils/axios';
import { FetchAndroidAppVersionList } from './fetch-android-app-version-list';

export namespace RemoveAndroidAppVersion {
  export type RequestType = {
    versionId: number;
  };

  export const useMutate = ({
    onSuccess,
    ...options
  }: UseMutationOptions<AxiosResponse, AxiosError, RequestType> = {}) => {
    const { refetch } = FetchAndroidAppVersionList.useRefetchData();

    const mutation = useMutation(
      ({ versionId }) => {
        return axios.delete(`/android/versions/${versionId}`);
      },
      {
        onSuccess: (...rest) => {
          refetch();
          onSuccess?.(...rest);
        },
        ...options
      }
    );

    return mutation;
  };
}
